import { RouteRecordName } from "vue-router"

export enum analyticsEvents {
  PAGE_VIEWED = "page_viewed",
  BUTTON_CLICKED = "button_clicked",
  LOG_IN = "log_in",
  USER_LANDED = "user_landed",
  SERVICE_CARD_SELECTED = "service_card_selected",
  TREATMENT_CONSENT_ACCEPTED = "treatment_consent_accepted",
  TREATMENT_CONSENT_TERMS_VIEWED = "treatment_consent_terms_viewed",
  ENROLLMENT_CSAT_GIVEN = "enrollment_csat_given",
  RECOMMENDATION_SURVEY_STARTED = "recommendation_survey_started",
  RECOMMENDATION_SURVEY_SUBMITTED = "recommendation_survey_submitted",
  RECOMMENDATION_REC_PAGE_RENDERED = "recommendation_rec_page_rendered",
  RECOMMENDATION_REC_PLAN_SELECTED = "recommendation_rec_plan_selected"
}

// Vitable Event Payloads
export type PageViewedProperties = {
  name: RouteRecordName | null | undefined
  path: string
  from_name: RouteRecordName | null | undefined
  from_path: string | null
}

export type ButtonClickedProperties = {
  page_name: string
  cta_text: string
  button_id?: Optional<string>
}

// App Specific Event Payloads

export type UserLandedProperties = {
  page_name: RouteRecordName | null | undefined
  from: string | null | undefined
  message_count: string | null | undefined
  plan_type: string | null | undefined
  campaign_version: string | null | undefined
  company_id: string | null | undefined
}

export type ServiceCardSelectedProperties = {
  visit_reason_id: string
  visit_reason_name: string
}

// Surface a recommendation was selected from — origin column or fallback path, not a plan tier.
export type RecommendationCardSurface =
  "best_fit" | "lowest_premium" | "lowest_expected_cost" | "skip_survey" | "mec_recommended" | "see_all"

export type RecommendationSurveyStartedProperties = {
  enrollment_id: string
}

export type RecommendationSurveySubmittedProperties = {
  enrollment_id: string
  survey_hash: string
  visible_step_count: number
}

export type RecommendationRecPageRenderedProperties = {
  enrollment_id: string
  plan_count: number
  criteria_held: Array<string>
}

export type RecommendationRecPlanSelectedProperties = {
  enrollment_id: string
  ideon_plan_id: string | null
  surface: RecommendationCardSurface
  was_recommended: boolean
}
